/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useCrmCustomerBirthdayList,
  useCrmCustomerCustomList,
  useCrmCustomerMarketingList,
  useCrmCustomerNextRevisionList,
  useCrmCustomerRecoveryDebtsList,
  useCrmCustomerSatisfactionSurveysList,
  useCrmCustomerWithoutMovimentList,
} from '@/core/domain/crm/CrmList/CrmList.hooks';
import { SendOptionType } from '@/core/domain/crm/SendOptions/SendOptions.types';
import { PageResult } from '@/core/request/PageResult';
import { UseInfiniteQueryResult } from 'react-query';

export const queryHooks: Record<
  SendOptionType,
  (params: any) => UseInfiniteQueryResult<PageResult<any>> | null
> = {
  [SendOptionType.birthdays]: useCrmCustomerBirthdayList,
  [SendOptionType.clientWithoutMovement]: useCrmCustomerWithoutMovimentList,
  [SendOptionType.custom]: useCrmCustomerCustomList,
  [SendOptionType.emailMarketing]: useCrmCustomerMarketingList,
  [SendOptionType.futureServices]: () => null,
  [SendOptionType.nextReviews]: useCrmCustomerNextRevisionList,
  [SendOptionType.recoveryOfDebts]: useCrmCustomerRecoveryDebtsList,
  [SendOptionType.satisfactionSurvey]: useCrmCustomerSatisfactionSurveysList,
};
